import React, {Component, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../shared/hoc/createAdminPage'
import {ACCESS_CONTROL_MANAGER, AVAILABLE_OR_NOT, PAYMENT_TYPE, RESIDENT_STATUS} from '../../../CodeMaster'
import FacilityForReservation from '../../facilities/FacilityForReservation'
import {ColumnFlexContainer, LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Box, Paper, Table, TableBody, TableCell, TableHead, TableRow} from '@mui/material';
import {PageFooterArea, PageFotterAreaLeft, PageFotterAreaRight} from '../../shared/hoc/withAdminPageTemplate'
import PPTextField from '../../shared/forms/PPTextField'
import PPSelect from '../../shared/forms/PPSelect'
import {addEmptyData, isNoSelect, NoSelectedValue, valueOrNoSelected} from '../../../componentHelper/selectHelper'
import {BackLink, StyledLink} from '../../../styledComponents/adminPage/Links'
import {
    AdminDefaultButton,
    AdminDefaultMediumButton,
    AdminPrimaryButton,
} from '../../../styledComponents/adminPage/Buttons'
import {ReservationsRepositoryForAdmin} from './ReservationsRepositoryForAdmin'
import {Nullable} from '../../../app/TypeHelpers'
import {AdminReserveLocationState, ReservationInfo} from './AdminReserveInterfaces'
import {AdminAgentReserveSteps, AdminReserveStepper} from './AdminReserveStepper'
import styled, {css} from 'styled-components'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import NatRoomToResidentRepo, {GetRoomToResidentParams} from '../../../__NoAutomatedTests/components/roomToResident/repository/NatRoomToResidentRepo'
import {
    NatGetRoomToResident,
    ResidentUserInfo,
} from '../../../__NoAutomatedTests/components/roomToResident/repository/NatGetRoomToResident'
import {Messages} from '../../../Messages'
import {HKConstants} from '../../../HKConstants'
import {SelectedUserList} from '../../../__NoAutomatedTests/components/facilityReserve/repository/NatGetFacilityReserve'
import NatRoomNumberRepo from '../../../__NoAutomatedTests/components/roomNumber/repository/NatRoomNumberRepo'
import NatRidgeRepo from '../../../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import AdminReserveUsersRoomNumberInput from './AdminReserveUsersRoomNumberInput'
import lsHelper from './AdminReserveLocationStateHelper'
import {
    getDisplayRoomNumber,
    getDisplaySelectedUserOrRoleName,
    getDisplayUserName,
    getDisplayUserNameForManagement,
} from './AdminReserveHelper'
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea'
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionColumNameCell,
    ConditionInputCell,
    ConditionTable,
    ConditionTableBody,
    ConditionTableRow,
} from '../../../styledComponents/adminPage/ConditionTable'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import {BoldSpan} from '../../../styledComponents/StyledSpan'
import {ReservationClass} from '../ReservationInterfaces'
import moment from 'moment'
import {SelectChangeEvent} from '@mui/material/Select'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    roomNumberRepo: NatRoomNumberRepo
    ridgeRepo: NatRidgeRepo
    roomToResidentRepo: NatRoomToResidentRepo
    reservationsRepoForAdmin: ReservationsRepositoryForAdmin
    location: Location<AdminReserveLocationState>
}

enum SearchStatus {
    BEFORE_SEARCH,
    SUCCESS,
    NO_RESULT,
    LIMIT_OVER,
}

interface State {
    facilityData: Nullable<FacilityForReservation>
    ridgeCd: string
    roomNumber: string
    familyName: string
    firstName: string
    familyNameKana: string
    firstNameKana: string
    userSearchStatus: SearchStatus
    userInfos: Nullable<ResidentUserInfo[]>
    selectedUser: Nullable<ResidentUserInfo>
    paymentType: Nullable<PAYMENT_TYPE>
    selectedRoomsOrDisabled: Nullable<SelectedUserList[]>
    isDataSelectCompleted: boolean
}

const KEY_PREVIOUS_PAGE_URL: string = 'AdminAgentReserveSelectUserPage.previousPageUrl'
const KEY_PREVIOUS_PAGE_NAME: string = 'AdminAgentReserveSelectUserPage.previousPageName'

class AdminAgentReserveSelectUserPage extends Component<Props & AdminPagePropsSet, State> {
    private locationState: AdminReserveLocationState
    private previousPageUrl: string
    private previousPageName: string

    private readonly residentListHeadLabels: string[] =
        ['', '部屋番号', '氏名', 'メインユーザ', '管理者確認用氏名', '権限', '予約可否']

    constructor(props: Readonly<Props & AdminPagePropsSet>) {
        super(props)

        if (!this.props.location || !this.props.location.state || !this.props.location.state.reservationInfo) {
            throw Error('前画面からの引き継ぎ情報がありません。画面遷移が不正です。')
        }
        const {previousPageUrl, previousPageName, ...rest} = this.props.location.state
        this.locationState = lsHelper.fromObject(rest)

        if (previousPageUrl !== undefined && previousPageName !== undefined) {
            this.previousPageUrl = previousPageUrl
            this.previousPageName = previousPageName
            SessionStorageHelper.setItem(KEY_PREVIOUS_PAGE_URL, previousPageUrl)
            SessionStorageHelper.setItem(KEY_PREVIOUS_PAGE_NAME, previousPageName)
        } else {
            const url: Nullable<string> = SessionStorageHelper.getStringItemOrNull(KEY_PREVIOUS_PAGE_URL)
            const name: Nullable<string> = SessionStorageHelper.getStringItemOrNull(KEY_PREVIOUS_PAGE_NAME)
            if (!url || !name) {
                throw Error('前画面のリンク情報がありません。画面遷移が不正です。')
            }
            this.previousPageUrl = url || ''
            this.previousPageName = name || ''
        }

        this.state = {
            facilityData: null,
            ridgeCd: '',
            roomNumber: '',
            familyName: '',
            firstName: '',
            familyNameKana: '',
            firstNameKana: '',
            userSearchStatus: SearchStatus.BEFORE_SEARCH,
            userInfos: null,
            selectedUser: null,
            paymentType: null,
            selectedRoomsOrDisabled: null,
            isDataSelectCompleted: false,
        }

        this.handleChangeUserList = this.handleChangeUserList.bind(this)
        this.handleChangeRidgeCode = this.handleChangeRidgeCode.bind(this)
        this.handleChangeRoomNumber = this.handleChangeRoomNumber.bind(this)
        this.handleChangeFamilyName = this.handleChangeFamilyName.bind(this)
        this.handleChangeFirstName = this.handleChangeFirstName.bind(this)
        this.handleChangeFamilyNameKana = this.handleChangeFamilyNameKana.bind(this)
        this.handleChangeFirstNameKana = this.handleChangeFirstNameKana.bind(this)
        this.handleClickClearSearchCondition = this.handleClickClearSearchCondition.bind(this)
        this.handleClickSearch = this.handleClickSearch.bind(this)
        this.handleClickSelectUser = this.handleClickSelectUser.bind(this)
        this.handleChangePaymentType = this.handleChangePaymentType.bind(this)
        this.handleClickPreviousPage = this.handleClickPreviousPage.bind(this)
        this.handleClickSubmitWithOption = this.handleClickSubmitWithOption.bind(this)
        this.handleClickSubmitWithoutOption = this.handleClickSubmitWithoutOption.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const facilityData: Nullable<FacilityForReservation> = await this.props.asyncCallFunction(
                this.props.reservationsRepoForAdmin.getFacilityForReservation.bind(
                    this.props.reservationsRepoForAdmin,
                    this.props.condominiumCd,
                    this.props.location.state.facilityId,
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (facilityData === null) {
                throw Error('facilityData cannot be null')
            }

            if (this.locationState.reservationInfo.classification === ReservationClass.MANAGER) {
                throw Error('代行予約の画面に管理者予約の情報が渡されています。')
            }

            const {userInfo, paymentType, selectedRoomsOrDisabled} = this.locationState.reservationInfo
            if (userInfo !== null && paymentType !== null) {
                let newSelectedRoomsOrDisabled: Nullable<SelectedUserList[]>
                if (this.isSharedUseRoomNumberDisabled(facilityData.accessControlManager)) {
                    newSelectedRoomsOrDisabled = null
                } else if (selectedRoomsOrDisabled === null) {
                    newSelectedRoomsOrDisabled = []
                } else {
                    newSelectedRoomsOrDisabled = selectedRoomsOrDisabled
                }
                this.restoreFromLocationState(facilityData, userInfo, paymentType, newSelectedRoomsOrDisabled)
            } else {
                const newSelectedRoomsOrDisabled: Nullable<SelectedUserList[]> =
                    facilityData.accessControlManager ? [] : null
                this.setState({facilityData, selectedRoomsOrDisabled: newSelectedRoomsOrDisabled})
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    isSharedUseRoomNumberDisabled(accessControlManager: Nullable<ACCESS_CONTROL_MANAGER>): boolean {
        return accessControlManager === null ||
            accessControlManager === ACCESS_CONTROL_MANAGER.RIKB
    }

    restoreFromLocationState(
        facilityData: FacilityForReservation,
        userInfo: ResidentUserInfo,
        paymentType: PAYMENT_TYPE,
        selectedRoomsOrDisabled: Nullable<SelectedUserList[]>,
    ): void {
        const isDataSelectCompleted: boolean = this.checkDataSetCompleted(userInfo, paymentType)

        this.setState({
            facilityData: facilityData,
            userSearchStatus: SearchStatus.SUCCESS,
            userInfos: [userInfo],
            selectedUser: userInfo,
            paymentType: paymentType,
            selectedRoomsOrDisabled: selectedRoomsOrDisabled,
            isDataSelectCompleted: isDataSelectCompleted,
        })
    }

    handleChangeRidgeCode(event: SelectChangeEvent<unknown>): void {
        const ridgeCd = event.target.value as string
        this.setState({ridgeCd: ridgeCd === NoSelectedValue ? '' : ridgeCd})
    }

    handleChangeRoomNumber(event: React.ChangeEvent<HTMLInputElement>): void {
        const roomNumber = event.target.value
        this.setState({roomNumber})
    }

    handleChangeFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        const familyName = event.target.value
        this.setState({familyName})
    }

    handleChangeFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        const firstName = event.target.value
        this.setState({firstName})
    }

    handleChangeFamilyNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        const familyNameKana = event.target.value
        this.setState({familyNameKana})
    }

    handleChangeFirstNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        const firstNameKana = event.target.value
        this.setState({firstNameKana})
    }

    handleClickClearSearchCondition(): void {
        this.setState({
            ridgeCd: '',
            roomNumber: '',
            familyName: '',
            firstName: '',
            familyNameKana: '',
            firstNameKana: '',
        })
    }

    async handleClickSearch(): Promise<void> {
        const {facilityData} = this.state
        if (facilityData === null) {
            throw Error('facilityData cannot be null')
        }

        await this.props.eventEmitter.showLoading()
        try {
            const requestParams: GetRoomToResidentParams = this.createRequestParams()

            const getResidentUsersResponse: Nullable<NatGetRoomToResident> =
                await this.props.asyncCallFunction(
                    this.props.roomToResidentRepo.getRoomToResident.bind(
                        this.props.roomToResidentRepo,
                        requestParams,
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
            if (getResidentUsersResponse === null || getResidentUsersResponse.details === null) {
                return
            }

            let userInfos: Nullable<ResidentUserInfo[]> = null
            let userSearchStatus: SearchStatus
            let selectedUser: Nullable<ResidentUserInfo> = null

            if (getResidentUsersResponse.details.searchResult.total === 0) {
                userSearchStatus = SearchStatus.NO_RESULT
            } else if (getResidentUsersResponse.details.searchResult.limitOverFlag === 1) {
                userSearchStatus = SearchStatus.LIMIT_OVER
            } else {
                userSearchStatus = SearchStatus.SUCCESS
                userInfos = getResidentUsersResponse.details.residentUserInfo
                if (userInfos.length === 1) {
                    const usersReserveAvailability: AVAILABLE_OR_NOT = AVAILABLE_OR_NOT.codeToEnumConstants(
                        userInfos[0].facilityReserveAvailability || AVAILABLE_OR_NOT.AVAILABLE.value,
                    )
                    if (usersReserveAvailability === AVAILABLE_OR_NOT.AVAILABLE) {
                        selectedUser = userInfos[0]
                    } else {
                        selectedUser = null
                    }
                }
            }

            const selectedRoomsOrDisabled: Nullable<SelectedUserList[]> =
                !this.isSharedUseRoomNumberDisabled(facilityData.accessControlManager) ? [] : null
            const paymentType: Nullable<PAYMENT_TYPE> = null
            const isDataSelectCompleted: boolean = this.checkDataSetCompleted(selectedUser, paymentType)

            this.setState({
                userSearchStatus,
                userInfos,
                selectedUser,
                paymentType,
                selectedRoomsOrDisabled,
                isDataSelectCompleted,
            })

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    createRequestParams(): GetRoomToResidentParams {
        const getRoomToResidentParams: GetRoomToResidentParams = {}
        const {ridgeCd, roomNumber, familyName, firstName, familyNameKana, firstNameKana} = this.state
        getRoomToResidentParams.condominiumCd = this.props.condominiumCd
        getRoomToResidentParams.status = `${RESIDENT_STATUS.UNREGISTERED.value},${RESIDENT_STATUS.REGISTERED.value},${RESIDENT_STATUS.BEFORE_OCCUPANCY.value}`

        if (ridgeCd) {
            getRoomToResidentParams.ridgeCd = ridgeCd
        }
        if (roomNumber) {
            getRoomToResidentParams.roomNumber = roomNumber
        }
        if (familyName) {
            getRoomToResidentParams.familyName = familyName
        }
        if (firstName) {
            getRoomToResidentParams.firstName = firstName
        }
        if (familyNameKana) {
            getRoomToResidentParams.familyNameKana = familyNameKana
        }
        if (firstNameKana) {
            getRoomToResidentParams.firstNameKana = firstNameKana
        }

        getRoomToResidentParams.sortInfo = []
        getRoomToResidentParams.sortInfo.push(`ridgeCd:asc`)
        getRoomToResidentParams.sortInfo.push(`roomNumber:asc`)

        getRoomToResidentParams.validPeriodCriteriaDate = moment(this.locationState.reservationInfo.startDate)

        return getRoomToResidentParams
    }

    checkDataSetCompleted(selectedUser: Nullable<ResidentUserInfo>, paymentType: Nullable<PAYMENT_TYPE>): boolean {
        return selectedUser !== null && paymentType !== null
    }

    handleClickSelectUser(
        selectedUser: ResidentUserInfo,
    ): () => void {
        const isDataSelectCompleted: boolean = this.checkDataSetCompleted(selectedUser, this.state.paymentType)
        return () => {
            this.setState({selectedUser, isDataSelectCompleted})
        }
    }

    handleChangePaymentType(event: SelectChangeEvent<unknown>): void {
        const value = event.target.value as string
        const paymentType: Nullable<PAYMENT_TYPE> =
            isNoSelect(value) ? null : PAYMENT_TYPE.codeToEnumConstants(value)
        const isDataSelectCompleted: boolean = this.checkDataSetCompleted(this.state.selectedUser, paymentType)
        this.setState({paymentType, isDataSelectCompleted})
    }


    handleClickPreviousPage(): void {
        this.props.navigate(this.previousPageUrl, {
            replace: true,
            state: lsHelper.toObject(this.locationState),
        })
    }

    handleClickSubmitWithOption(): void {
        this.handleClickSubmit(`/admin/condominiums/${this.props.condominiumCd}/agent-reserve/select-option`)
    }

    handleClickSubmitWithoutOption(): void {
        this.handleClickSubmit(`/admin/condominiums/${this.props.condominiumCd}/agent-reserve/confirm`)
    }

    private handleClickSubmit(nextPath: string): void {
        const {
            selectedUser,
            paymentType,
            selectedRoomsOrDisabled,
            facilityData,
        } = this.state

        if (selectedUser === null || paymentType === null) {
            return
        }

        const {reservationInfo, ...rest} = this.locationState
        const newReservationInfo: ReservationInfo = {
            ...reservationInfo,
            classification: ReservationClass.AGENT,
            userInfo: selectedUser,
            paymentType,
            selectedRoomsOrDisabled: selectedRoomsOrDisabled,
        }
        const newAdminReserveLocationState: AdminReserveLocationState = {
            ...rest,
            reservationInfo: newReservationInfo,
            facilityData: facilityData,
            previousPageUrl:
                `/admin/condominiums/${this.props.condominiumCd}/agent-reserve/select-user`,
            previousPageName: '利用者・支払方法選択',
        }

        this.props.navigate(
            nextPath,
            {
                replace: true,
                state: lsHelper.toObject(newAdminReserveLocationState),
            },
        )
    }

    renderSearchFormArea(): ReactNode {
        return (<Paper>
            <ListSearchFormArea onEnterKey={this.handleClickSearch}>
                <ConditionTable>
                    <ConditionTableBody>
                        {this.renderCondominiumConditionRow()}
                        {this.renderResidentConditionAndButtonRow()}
                    </ConditionTableBody>
                </ConditionTable>
            </ListSearchFormArea>
        </Paper>)
    }

    renderCondominiumConditionRow(): ReactNode {
        return (<>
            <ConditionTableRow>
                <ConditionCategoryCell rowSpan={2}>物件情報</ConditionCategoryCell>
                <ConditionColumNameCell>棟名</ConditionColumNameCell>
                <ConditionInputCell>
                    <PPSelect
                        data={addEmptyData(this.locationState.ridgeInfos.map(ridge => (
                            {label: `${ridge.ridgeCd}：${ridge.ridgeName}`, value: ridge.ridgeCd}
                        )))}
                        fullWidth
                        onChange={this.handleChangeRidgeCode}
                        value={this.state.ridgeCd}
                    />
                </ConditionInputCell>
            </ConditionTableRow>
            <ConditionTableRow>
                <ConditionColumNameCell>部屋番号</ConditionColumNameCell>
                <ConditionInputCell>
                    <PPTextField
                        InputProps={{
                            inputProps: {
                                maxLength: 4,
                            },
                        }}
                        fullWidth
                        onChange={this.handleChangeRoomNumber}
                        value={this.state.roomNumber}
                    />
                </ConditionInputCell>
            </ConditionTableRow>
        </>)
    }

    renderResidentConditionAndButtonRow(): ReactNode {
        return (<>
            <ConditionTableRow>
                <ConditionCategoryCell rowSpan={2}>居住者情報</ConditionCategoryCell>
                <ConditionColumNameCell>氏名</ConditionColumNameCell>
                <ConditionInputCell>
                    <LeftRowFlexContainer>
                        <FlexContainerColumn>
                            <span>姓</span>
                            <NameWrapper>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 10,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.handleChangeFamilyName}
                                    value={this.state.familyName}
                                />
                            </NameWrapper>
                        </FlexContainerColumn>
                        <FlexContainerColumn>
                            <span>名</span>
                            <NameWrapper>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 10,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.handleChangeFirstName}
                                    value={this.state.firstName}
                                />
                            </NameWrapper>
                        </FlexContainerColumn>
                    </LeftRowFlexContainer>
                </ConditionInputCell>
            </ConditionTableRow>
            <ConditionTableRow>
                <ConditionColumNameCell>氏名(フリガナ)</ConditionColumNameCell>
                <ConditionInputCell>
                    <LeftRowFlexContainer>
                        <FlexContainerColumn>
                            <span>セイ</span>
                            <NameWrapper>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 20,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.handleChangeFamilyNameKana}
                                    value={this.state.familyNameKana}
                                />
                            </NameWrapper>
                        </FlexContainerColumn>
                        <FlexContainerColumn>
                            <span>メイ</span>
                            <NameWrapper>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 20,
                                        },
                                    }}
                                    fullWidth
                                    onChange={this.handleChangeFirstNameKana}
                                    value={this.state.firstNameKana}
                                />
                            </NameWrapper>
                        </FlexContainerColumn>
                    </LeftRowFlexContainer>
                </ConditionInputCell>
                <ConditionButtonCell>
                    <ColumnFlexContainer>
                        <AdminDefaultMediumButton onClick={this.handleClickSearch}>
                            検索する
                        </AdminDefaultMediumButton>
                        <Box mt={'10px'}>
                            <StyledLink onClick={this.handleClickClearSearchCondition}>検索条件をクリア</StyledLink>
                        </Box>
                    </ColumnFlexContainer>
                </ConditionButtonCell>
            </ConditionTableRow>
        </>)
    }

    renderResidentUserListArea(): ReactNode {
        let searchMessageArea: ReactNode = null
        let searchResultArea: ReactNode = null

        switch (this.state.userSearchStatus) {
            case SearchStatus.BEFORE_SEARCH:
                searchMessageArea = null
                break
            case SearchStatus.NO_RESULT:
                searchMessageArea = <div>{Messages.IOPCC0014.toString()}</div>
                break
            case SearchStatus.LIMIT_OVER:
                searchMessageArea =
                    <div>{Messages.IOPCC0016.toString(HKConstants.VMN.RES.RESIDENCE_USER_SEARCH_RESULTS_LIMIT)}</div>
                break
            case SearchStatus.SUCCESS:
                const {userInfos} = this.state
                if (userInfos === null || userInfos.length === 0) {
                    throw Error('検索結果ステータスが成功状態で検索結果が空です。')
                }

                searchMessageArea = <div>{`${userInfos.length}件該当しました。予約する居住者を選択してください。`}</div>
                searchResultArea = this.renderResidentList(userInfos)
                break
            default:
        }

        return (<>
            <Box mt={'10px'} mb={'10px'}>
                {searchMessageArea}
            </Box>
            <Paper>
                <Box flexGrow={10}>
                    {searchResultArea}
                </Box>
            </Paper>
        </>)
    }

    renderResidentList(userInfos: ResidentUserInfo[]): ReactNode {
        return <>
            <Table>
                <TableHead>
                    <TableRow>
                        {
                            this.residentListHeadLabels
                                .map((label, index) => <TableCell key={index}>{label}</TableCell>)
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {userInfos.map((info, index) => this.renderResidentListRow(info, index))}
                </TableBody>
            </Table>
        </>
    }

    renderResidentListRow(userInfo: ResidentUserInfo, index: number): ReactNode {
        const displayRoomNumber = getDisplayRoomNumber(userInfo)
        const displayUserName = getDisplayUserName(userInfo)
        const displayUserNameForManagement = getDisplayUserNameForManagement(userInfo)
        const usersReserveAvailability: AVAILABLE_OR_NOT = AVAILABLE_OR_NOT.codeToEnumConstants(
            userInfo.facilityReserveAvailability || AVAILABLE_OR_NOT.UNAVAILABLE.value,
        )
        const disableUser = (usersReserveAvailability === AVAILABLE_OR_NOT.UNAVAILABLE)

        return (<SelectableTableRow
            key={index}
            selected={this.state.selectedUser === userInfo}
            disabled={disableUser}
        >
            <TableCell>
                <ToggleButton
                    size={'small'}
                    selected={this.state.selectedUser === userInfo}
                    onClick={
                        this.handleClickSelectUser(
                            userInfo,
                        )
                    }
                    disabled={disableUser}
                >
                    {this.state.selectedUser === userInfo ? '選択済み' : '選択する'}
                </ToggleButton>
            </TableCell>
            <TableCell>{displayRoomNumber}</TableCell>
            <TableCell>{displayUserName}</TableCell>
            <TableCell>
                {userInfo.parentFamilyName && `${userInfo.parentFamilyName} ${userInfo.parentFirstName}`}
            </TableCell>
            <TableCell>{displayUserNameForManagement}</TableCell>
            <TableCell>{userInfo.roleName}</TableCell>
            <TableCell>{usersReserveAvailability.label}</TableCell>
        </SelectableTableRow>)
    }

    renderSelectPaymentTypeAndCardKeysArea(): ReactNode {
        const {selectedUser, selectedRoomsOrDisabled, facilityData} = this.state
        if (selectedUser === null || facilityData === null) {
            return null
        }

        const userName: string = getDisplaySelectedUserOrRoleName(selectedUser)
        const paymentTypesForFacility = PAYMENT_TYPE.values()
            .filter((type) => type !== PAYMENT_TYPE.SERVICE_TRANSFER_ACCOUNT)

        return (<>
            <Box mt={'10px'} mb={'10px'}>
                <div>
                    <BoldSpan>
                        {`${selectedUser.ridgeName} ${selectedUser.roomNumber}`}
                    </BoldSpan> <BoldSpan>{userName}</BoldSpan> さんを選択しています。
                </div>
                <div>お支払方法を選択してください。</div>
            </Box>
            <PaddingPaper>
                <label>
                    <LeftRowFlexContainer>
                        お支払い方法
                        <Box ml={'20px'}>
                            <PPSelect
                                data={addEmptyData(paymentTypesForFacility)}
                                onChange={this.handleChangePaymentType}
                                value={valueOrNoSelected(this.state.paymentType)}
                            />
                        </Box>
                    </LeftRowFlexContainer>
                </label>
                {
                    (selectedRoomsOrDisabled !== null) &&
                    (facilityData.accessControlManager !== null &&
                        facilityData.accessControlManager !== ACCESS_CONTROL_MANAGER.RIKB) &&
                    <Box mt={'10px'}>
                        <AdminReserveUsersRoomNumberInput
                            condominiumCd={this.props.condominiumCd}
                            roomToResidentRepo={this.props.roomToResidentRepo}
                            ridgeRepo={this.props.ridgeRepo}
                            onChangeUserList={this.handleChangeUserList}
                            eventEmitter={this.props.eventEmitter}
                            selectedUserList={selectedRoomsOrDisabled}
                            excludeSelectedUser={selectedUser}
                            asyncCallFunction={this.props.asyncCallFunction}
                            navigate={this.props.navigate}
                            location={this.props.location}
                            validPeriodCriteriaDate={moment(this.locationState.reservationInfo.startDate)}
                            accessControlManager={facilityData.accessControlManager}
                        />
                    </Box>
                }
            </PaddingPaper>
        </>)
    }

    handleChangeUserList(users: SelectedUserList[]): void {
        this.setState({
            selectedRoomsOrDisabled: users,
        })
    }

    render(): ReactNode {
        const {facilityData} = this.state
        if (!facilityData) {
            return null
        }

        const hasOptions: boolean = facilityData.facilityOptions.length > 0

        return (<>
            <Box height={'108px'} bgcolor={'#ffffff'} padding={'24px'}>
            <AdminReserveStepper
                classification={ReservationClass.AGENT}
                step={AdminAgentReserveSteps.SELECT_USER}
                hasOption={hasOptions}
            />
            </Box>
            <Box mt={'10px'} mb={'10px'}>
                <BoldSpan>{facilityData.facilityName}</BoldSpan> を代行予約受付
                <div>{Messages.IOPCC0017.toString('検索する')}</div>
            </Box>
            {this.renderSearchFormArea()}
            {this.renderResidentUserListArea()}
            {this.renderSelectPaymentTypeAndCardKeysArea()}
            <PageFooterArea>
                <PageFotterAreaLeft>
                    <BackLink onClick={this.handleClickPreviousPage}>
                        {`${this.previousPageName}に戻る`}
                    </BackLink>
                </PageFotterAreaLeft>
                <PageFotterAreaRight>
                    {
                        facilityData.facilityOptions.length > 0
                            ? <AdminPrimaryButton
                                onClick={this.handleClickSubmitWithOption}
                                disabled={!this.state.isDataSelectCompleted}
                            >
                                オプション選択に進む
                            </AdminPrimaryButton>
                            : <AdminPrimaryButton
                                onClick={this.handleClickSubmitWithoutOption}
                                disabled={!this.state.isDataSelectCompleted}
                            >
                                予約内容確認に進む
                            </AdminPrimaryButton>
                    }
                </PageFotterAreaRight>
            </PageFooterArea>
        </>)
    }
}

export default createAdminPage(AdminAgentReserveSelectUserPage)

interface ToggleButtonProps {
    selected: boolean
}

const ToggleButton = styled(AdminDefaultButton)<ToggleButtonProps>`
  ${props => {
    if (props.selected) {
      return css`
        &.MuiButton-contained, &.MuiButton-contained:hover {
          box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08), 0 4px 10px -6px #000000 inset;
          -moz-box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08), 0 4px 10px -6px #000000 inset;
          -webkit-box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08), 0 4px 10px -6px #000000 inset;
        }
      `
    }
  }
  }`

const FlexContainerColumn: StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  &:first-child {
    padding: 0 12px 0 0;
  }
`

const NameWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
`

const PaddingPaper = styled(Paper)`
  padding: 16px;
`

const SelectableTableRow = styled(TableRow)<{ disabled?: boolean }>`
  background-color: ${props =>
          props.disabled ? 'rgba(0, 0, 0, 0.2)' : props.selected ? 'rgb(255, 217, 102)!important' : 'white'};
`
